export const DEFAULT_TRIM_CTA_NAME = 'Find Best Price';
export const FRANCHISE_LIMIT = 25; // TODO: Should be removed when clean up QB-43-New-Core-V3-Signup
